<script lang="ts">
	import { iconValues, type Icon } from '$lib/types/icons';

	interface Props {
		src: Icon;
		className?: string;
	}

	let { src, className = '' }: Props = $props();

	async function loadComponent(icon: string) {
		if (icon === '') return null;

		if (iconValues.includes(icon)) {
			try {
				const module = await import(`$lib/svg/${icon}.svg.svelte`);
				return module.default;
			} catch (error) {
				console.error(`Icon "${icon}" not found`, error);
				return null;
			}
		} else {
			try {
				const module = await import(`@lucide/svelte`);
				if (module[icon]) {
					return module[icon];
				}
			} catch (error) {
				throw new Error(`Icon "${icon}" not found in @lucide/svelte`);
			}
		}
	}
</script>

{#await loadComponent(src) then Component}
	{#if Component}
		<Component
			className={className + ' flex-none'}
			class={className + ' flex-none'}
			strokeWidth={1.25}
		/>
	{:else if src !== ''}
		<p class="bg-error text-error-on">Icon not found</p>
	{/if}
{/await}
